export default "__VITE_PUBLIC_ASSET__5267a698__"